'use client';
import React, { useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import './AnnouncementComponent.css';

const AnnouncementComponent = ({ newsItems }) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 769px)' });

  const animationSettings = useMemo(() => {
    const totalTextLength = newsItems.reduce(
      (total, item) => total + item.title.length + item.description.length,
      0
    );
    const scrollSpeed = isDesktopOrLaptop ? 0.09 : 0.0; // Consistent speed on smaller screens
    const animationDuration = Math.max(30, totalTextLength * scrollSpeed); // Ensuring a smoother transition
    return {
      animationDuration: `${animationDuration}s`,
    };
  }, [newsItems, isDesktopOrLaptop]);

  return (
    <Container fluid className="announcement-container">
      <Row className="ticker-container">
        <Col
          lg={2}
          md={3}
          className="announcement-bar"
          data-aos="zoom-out"
          data-aos-offset="0"
        >
          <span className="announcement-heading">Announcements : </span>
        </Col>
        <Col
          lg={10}
          sm={12}
          className="ticker-column"
          data-aos="slide-left"
          data-aos-offset="0"
          data-aos-duration="1500"
        >
          <div className="ticker-news" style={animationSettings}>
            {newsItems.map((item, index) => (
              <span key={index} className="ticker-item">
                <strong className="news-heading">{item.title}:</strong>
                <span className="news-description">{item.description}</span>
              </span>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AnnouncementComponent;
